import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { PersonService } from '../service/person.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'timeaxis-selecter-app',
  templateUrl: './timeaxis-selecter.component.html',
  styleUrls: ['timeaxis-selecter.component.css']
})

export class TimeaxisSelecterComponent {
  @Input() timeaxisList: any[];
  @Input() selectedIds: string;
  @Input() timeaxisListId: number;

  selectTimeaxisListId: number = null;
  selectTimeaxisList: any = [];
  selectList: any = [];
  selectListNames: any = [];
  selectNames:string = null;
  list: any = [];                       //質問、回答を含めた配列
  check_answer_list: any = [];          //チェックが入れられた回答のリスト
  check_all: boolean = false;           //全選択・全解除

  constructor(
    public commonService: CommonService,
    private personService: PersonService,
    public activeModal: NgbActiveModal,
  ) { }

  ret: any = {
    // status: "",
    select_tqc_id: "",
    answer_list: [],
  }

  //起動時処理
  ngOnInit(): void {
    //モーダル内セレクトボックスの初期値設定
    if(this.timeaxisListId == null){
      this.selectTimeaxisListId = this.timeaxisList[0]["m_timeaxis_list_id"];
    }else{
      this.selectTimeaxisListId = this.timeaxisListId;
    }
      this.getTimeaxis(this.selectTimeaxisListId);
      this.checkListInit();
  };
  checkListInit(): void {
    var ids = Array();
    if(this.selectedIds != null && this.selectedIds != undefined && this.selectedIds != ""){
      ids = this.selectedIds.split(',');
    }
    for(let i in this.timeaxisList){
      for(let c in this.timeaxisList[i]['timeaxis_data']){
        this.timeaxisList[i]['timeaxis_data'][c]['enabled'] = false;
        for(let k in ids){
          if(this.timeaxisList[i]['timeaxis_data'][c]['m_timeaxis_id'] == ids[k]){
            this.timeaxisList[i]['timeaxis_data'][c]['enabled'] = true;
          }
        }
      }
    }
  }
  modalCloseOK() {
    this.checkTimeaxis();
    this.ret.status = 'OK';
    this.ret.result = this.selectedIds;
    this.ret.resultNames = this.selectListNames;
    this.ret.timeaxisListId = this.selectTimeaxisListId;
    this.activeModal.close(this.ret);
  }
  checkTimeaxis(): void {
    var tempList = [];
    this.selectList = [];
    this.selectedIds = null;
    for(let i in this.timeaxisList){
      tempList = this.timeaxisList[i]['timeaxis_data'].filter(item => item.enabled === true);
      for(let c in tempList){
        this.selectList.push(tempList[c]['m_timeaxis_id']);
        this.selectListNames.push(tempList[c]['content']);
      }
    }
    if(this.selectList.length>0){
      this.selectedIds = this.selectList.join(',');
      this.selectNames = this.selectListNames.join(',');
    }
  }
  getTimeaxis(id:any){
    this.selectTimeaxisList = this.timeaxisList.filter(item => item.m_timeaxis_list_id == id);
    this.selectTimeaxisList = this.selectTimeaxisList[0];
    this.check_all = false;
    scrollTo(0, 0);
  }
  checkAll(id:any): void {
    if(this.check_all == false){
      for(let i in this.selectTimeaxisList.timeaxis_data){
        this.selectTimeaxisList.timeaxis_data[i].enabled = true;
      }
      this.check_all = true;
    } else {
      for(let i in this.selectTimeaxisList.timeaxis_data){
        this.selectTimeaxisList.timeaxis_data[i].enabled = false;
      }
      this.check_all = false;
    }
  }
  //キャンセル時
  modalCloseCancel() {
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a2103-yoyaku-register/timeaxis-selecter.component.ts